import React from "react";
import { Box, Text } from "@twilio-paste/core";
import { UnlockIcon } from "@twilio-paste/icons/esm/UnlockIcon";
import { LockIcon } from "@twilio-paste/icons/esm/LockIcon";

export type MetaInfoProps = {
  dateLabel: string;
  operatorLabel?: string;
  isAvailable: boolean;
  lockDisabled?: boolean;
  lockTooltip?: string;
};

export const MetaInfo: React.FC<MetaInfoProps> = ({
  dateLabel,
  operatorLabel,
  isAvailable,
  lockDisabled = false,
  lockTooltip,
}) => {
  const showLocked = lockDisabled || !isAvailable;

  const iconTitle = lockDisabled
    ? lockTooltip ?? "Conversazione bloccata"
    : isAvailable
    ? "Disponibile"
    : "Occupata";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-end"
      marginLeft="space30"
    >
      <Text
        as="span"
        fontSize="fontSize20"
        color="colorTextWeak"
        whiteSpace="nowrap"
      >
        {dateLabel}
      </Text>

      <Box
        display="flex"
        alignItems="center"
        marginTop="space20"
        columnGap="space20"
        opacity={lockDisabled ? 0.7 : 1}
      >
        {showLocked ? (
          <LockIcon decorative={false} title={iconTitle} size="sizeIcon40" />
        ) : (
          <UnlockIcon decorative={false} title={iconTitle} size="sizeIcon40" />
        )}

        {operatorLabel && (
          <Text
            as="span"
            fontSize="fontSize10"
            color="colorTextWeak"
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            textAlign="right"
          >
            {operatorLabel}
          </Text>
        )}
      </Box>
    </Box>
  );
};
